import React, { useState, useEffect } from 'react';
import { useSecurityStatus } from '../../hooks/security';
import { PrivacyFooter } from '../Shared/PrivacyFooter';
import { useIdleTimer } from 'react-idle-timer';
import { RiTimerLine } from 'react-icons/ri';
import { getLogo, removeData } from '../Shared/Functions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { withToast } from '../Shared/Toast';
import { Navigation } from './Navigation';
import { HeaderBar } from './HeaderBar';
import { AccountSelect } from './AccountSelect';
import { AccountInfo } from './AccountInfo';
import { PageTitle } from './PageTitle';

// Inactivity timeout, set to 10 minutes
const timeout = 10 * 60 * 1000;

const Dashboard = ({ accounts, account, setAccount, children, errorToast }) => {
    let [idle, setIdle] = useState<boolean>(false)
    let [logoutTimer, setLogoutTimer] = useState<any>(undefined)
    let [logo, setLogo] = useState<string>("")
    let { logout } = useSecurityStatus()

    const onIdle = () => setIdle(true);

    useIdleTimer({ timeout, onIdle })

    useEffect(() => {
        getLogo().then((x:any) => setLogo(x))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (idle) {
            // When idle, set a 60 second timer to auto logout
            setLogoutTimer(setTimeout(() => logoutCallback(), 60 * 1000))
        } else {
            clearTimeout(logoutTimer)
        }
    }, [idle])// eslint-disable-line react-hooks/exhaustive-deps

    const logoutCallback = () => {
        removeData("billingAccount")
        logout();
    }

    return (
        <>
            <a href="#main-content" className="sr-only sr-only-focusable">Skip to main content</a>
            <Dialog onClose={() => { }} open={idle} disablePortal>
                <DialogTitle>
                    <span style={{ padding: "1em" }}>Inactivity Notice</span>
                    <RiTimerLine className="float-left" key="timeout" size={40} />
                </DialogTitle>
                <DialogContent>
                    You have been inactive for a while.
                    For your security, we will automatically sign you out
                    in approximately 1 minute. You may choose
                    "Stay signed in" to continue or sign out if you are done.
                </DialogContent>
                <DialogActions className='timeout-buttons-group'>
                    <Button variant="outlined" color="primary" onClick={() => logoutCallback()} style={{marginRight:"10px"}}>Sign Out</Button>
                    <Button variant="contained" onClick={() => setIdle(false)}>Stay Signed In</Button>
                </DialogActions>
            </Dialog>
            <Grid container id="dashboard" style={{ width:"100%", height: "auto" }} className={'main-content'}>
                <Grid item xs={12} id="header-bar">
                    <HeaderBar account={account} logo={logo} />
                </Grid>
                <Grid item xs={12} id="nav-bar">
                    <Navigation account={account} />
                </Grid>
                <Grid item xs={12}>
                    <PageTitle />
                </Grid>
                <Grid className='content-container'>
                    <Grid item sm={12} style={{ marginTop: "15px", marginBottom: "15px" }}>
                        <Grid style={{ display: "block", marginLeft: "auto", marginRight: "auto", maxWidth:"1200px" }}>
                            <div className='account-select-display' style={{display: "flex", justifyContent: "space-between", alignContent: "end"}}>
                                <AccountInfo account={account} />
                                <AccountSelect accounts={accounts} setAccount={setAccount} errorToast={errorToast} />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} className={'main-content'} id="main-content">
                        <Grid style={{ display: "block", marginLeft: "auto", marginRight: "auto", maxWidth:"1200px" }}>
                            {children}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={12} id="privacy-footer" style={{ marginBottom: "10px", marginLeft: "auto", marginRight: "auto" }}>
                    <PrivacyFooter />
                </Grid>
            </Grid>
        </>)
}

export default withToast(Dashboard)
